module.exports = __webpack_public_path__ + "img/livro_reclamacoes.797a1b0e.png";